import $ from 'jquery';
import Vue from 'vue';
import queue from 'async/queue';
import findIndex from 'lodash.findindex';

const App = function (router) {
    const $this = this;
    this.eventBus = new Vue();
    this.stopQueue = false;
    this.queue = queue(function (task, callback) {
        if ($this.stopQueue == false) {
            var headers = {};
            if (task.hasOwnProperty('headers')) {
                headers = task.headers;
            }
            headers['Authorization'] = 'Bearer ' + $this.getAccessToken();
            $.ajax({
                url: task.url,
                method: task.method,
                data: task.params,
                headers: headers
            }).done(function (data, textStatus, jqXHR) {
                callback(jqXHR);
            }).fail(function (jqXHR) {
                if (jqXHR.status == 401) {
                    $this.stopQueue = true;
                    $this.queue.kill();
                    router.push('/login');
                    callback(jqXHR);
                } else {
                    callback(jqXHR);
                }
            });
        } else {
            callback();
        }
    }, 1);
};

App.prototype.post = function (url, params, callback, headers) {
    if (callback == undefined) {
        callback = params;
        params = {}
    }
    if (headers == undefined) {
        headers = {};
    }
    this.queue.push({method: 'post', url: url, params: params, headers: headers}, function (jqXHR) {
        if (jqXHR != undefined && jqXHR.status != 401) {
            callback(jqXHR)
        }
    });
};

App.prototype.get = function (url, params, callback, headers) {
    if (callback == undefined) {
        callback = params;
        params = {}
    }
    if (headers == undefined) {
        headers = {};
    }
    this.queue.push({method: 'get', url: url, params: params, headers: headers}, function (jqXHR) {
        if (jqXHR != undefined && jqXHR.status != 401) {
            callback(jqXHR)
        }
    });
};

App.prototype.isAuthenticated = function () {
    return localStorage.getItem('user') !== null;
};

App.prototype.getAccessToken = function () {
    return this.isAuthenticated() ? this.getUser().token.access_token : '';
};

App.prototype.authenticate = function (data) {
    this.stopQueue = false;
    this.updateUser(data);
};

App.prototype.clear = function () {
    localStorage.removeItem('user');
};

App.prototype.getUser = function () {
    return JSON.parse(localStorage.getItem('user'));
};

App.prototype.updateUser = function (data) {
    localStorage.setItem('user', JSON.stringify(data));
};

App.prototype.setTimezone = function (timezone) {
    localStorage.setItem('timezone', timezone);
};

App.prototype.getTimezone = function () {
    var timezone = localStorage.getItem('timezone');
    if (timezone == null) {
        timezone = 'Europe/Istanbul';
    }
    return timezone;
};

App.prototype.getDefaultDashboard = function () {
    var user = this.getUser();
    if (user.dashboards.length > 0) {
        var dashboard = user.dashboards[0];
        if (user.defaultDashboard > 0) {
            var defaultDashboardIndex = findIndex(user.dashboards, function (dashboard) {return dashboard.id === user.defaultDashboard;});
            dashboard = user.dashboards[defaultDashboardIndex];
        }
        return dashboard;
    } else {
        return null;
    }
};

App.prototype.updateDashboards = function (dashboards) {
    var user = this.getUser();
    user.dashboards = dashboards;
    localStorage.setItem('user', JSON.stringify(user));
};

App.prototype.setValue = function (key, value) {
    localStorage.setItem(key, JSON.stringify(value));
};

App.prototype.getValue = function (key) {
    if (localStorage.hasOwnProperty(key)) {
        return JSON.parse(localStorage.getItem(key));
    } else {
        return null;
    }
};

App.prototype.hasPermission = function (permission) {
    return this.getUser().permissions.hasOwnProperty(permission);
};

export default {
    install: function (Vue, options) {
        let app = new App(options.router);
        Vue.mixin({
            beforeRouteEnter: function (to, from, next) {
                if (to.path != '/login' && app.isAuthenticated() == false) {
                    next('/login');
                } else {
                    next();
                }
            }
        });
        Vue.prototype.$app = app;
        Vue.prototype.$eventHub = new Vue();
    }
}



// WEBPACK FOOTER //
// ./public/src/plugins/app.js